import { useTranslation } from 'react-i18next';
import { addVat } from '../../../Core/Services/PaymentService';
import Currencies from '../../../Core/Enums/Currencies';
export default function SizeTypeItem({
  key,
  type,
  setSelectedSize,
  selectedSize,
  setSelectedLevel,
}) {
  const { t, i18n } = useTranslation();
  return (
    <div
      onClick={() => {
        type.availableAmount > 0 && setSelectedSizeAndLevel(type);
      }}
      className={`containerListItem !border !border-solid p-8 cursor-pointer transition-colors ${
        selectedSize && selectedSize.id === type.id
          ? 'bg-[#F2F5F8] border-[#C6D0E5]'
          : 'border-gray-300 hover:bg-blue-50 hover:border-blue-400'
      }`}
      style={
        type.availableAmount === 0
          ? { opacity: 0.5, cursor: 'not-allowed' }
          : {}
      }
    >
      <div className="flex flex-col justify-start  md:flex-row md:justify-between md:items-center">
        <div className=" font-bold text-lg">{type.title}</div>
        {type.availableAmount > 0 && addVat(type.fromPrice) > 0 && (
          <div className=" font-bold text-lg">
            {t('container_from_price', {
              price: addVat(type.fromPrice).toLocaleString(i18n.language, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }),
              currency: Currencies.getCodeByValue(type.currency),
            })}{' '}
            <div className="text-sm font-normal text-end text-gray-400">
              {' '}
              {t('incl_vat')}
            </div>
          </div>
        )}
      </div>
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
        <div className="text-sm">{type.description}</div>
      </div>
      <div className="w-full flex items-end">
        {type.availableAmount > 0 && (
          <div className="text-red-300 text-sm mt-2">
            <span style={{ whiteSpace: 'nowrap' }}>
              {type.availableAmount} {t('units_available')}
            </span>
          </div>
        )}
      </div>
    </div>
  );

  function setSelectedSizeAndLevel(sizeType) {
    setSelectedSize(sizeType);
    for (let index = 0; index < sizeType.levelPrice.length; index++) {
      const price = sizeType.levelPrice[index];
      if (price != null && price > 0) {
        setSelectedLevel(index);
        break;
      }
    }
  }
}
